<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="w-full bg-primary items-center px-8 py-6 flex">
        <div>
          <p
            @click="handleback('cmsmanagement')"
            class="gap-2 cursor-pointer fsize14 mb-4 text-white flex items-center"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-2 text-2xl capitalize font-semibold">
            SEO & Google Analytics
          </h2>
          <p class="text-white pt-1 text-sm capitalize font-normal">
            Smart people tend to use this to stay ahead in the game.
          </p>
        </div>
      </div>
    </div>

    <div class="px-8 py-10">
      <div class="grid grid-cols-3 gap-6">
        <div class="sitemap-card cursor-pointer bg-white">
          <div class="bg-31b3eb cust-bgIcon">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/brained-admin/sitemap.svg"
              alt="sitemap"
              class="cust-wh5rem"
            />
          </div>
          <h1 class="text-2xl font-semibold mt-4">Download Sitemap</h1>
          <p class="text-737373 text-sm py-2">
            Get an XML File of your sitemap to upload on google console.
          </p>

          <el-button
            type="success"
            icon="el-icon-download"
            class="rounded-full cust-elbutton my-4 font-semibold"
            >Download Now</el-button
          >

          <div class="bg-ffd03f h-150px radius-16px mt-4 relative">
            <div class="absolute bottom-4 px-8 pb-4">
              <h1 class="text-primary text-2xl font-semibold mb-1">SEO 101</h1>
              <small class="text-primary font-semibold"
                >Here's a quick guide to<br />getting your website ranked.
              </small>
            </div>
          </div>
        </div>

        <div class="sitemap-card cursor-pointer bg-white">
          <div class="bg-ffecc7 h-200px radius-16px relative">
            <div class="absolute p-8">
              <h1 class="text-eb8134 text-2xl font-semibold mb-1">
                Lets Connect your website to QA
              </h1>
              <small class="text-eb8134 font-semibold"
                >Here's a quick guide to<br />getting your website ranked.
              </small>
            </div>
          </div>

          <h1 class="text-2xl font-semibold mt-8">Google Analytics</h1>
          <p class="text-737373 text-sm py-2">
            Paste your tag here to connect your website to Google Analytics
          </p>

          <el-button class="w-full text-rgba-gray mt-2 font-semibold" plain
            >Paste your GA Tag</el-button
          >

          <el-button
            type="success"
            class="rounded-full w-full cust-elbutton my-4 font-semibold"
            >Verify Tag</el-button
          >
        </div>

        <div class="sitemap-card cursor-pointer bg-white">
          <h1 class="text-2xl font-semibold mb-4">On Site SEO Settings</h1>
          <p class="text-737373 text-sm">
            Paste your tag here to connect your website to Google Analytics
          </p>

          <div class="mt-8">
            <div
              class="bg-f8f8f8 radius-6px bg-graycards flex gap-4 items-center mb-2"
            >
              <feather-icon
                class="flex"
                icon="GlobeIcon"
                svgClasses="w-6 h-6"
              />
              <div class="flex items-center justify-between w-full">
                <h1 class="text-sm">Optimize Pages</h1>

                <div class="flex items-center">
                  <feather-icon
                    class="flex"
                    icon="ArrowRightIcon"
                    svgClasses="w-6 h-6"
                  />
                </div>
              </div>
            </div>

            <div
              class="bg-f8f8f8 radius-6px bg-graycards flex gap-4 items-center mb-2"
            >
              <feather-icon
                class="flex"
                icon="FileTextIcon"
                svgClasses="w-6 h-6"
              />
              <div class="flex items-center justify-between w-full">
                <h1 class="text-sm">Schema Defination</h1>

                <div class="flex items-center">
                  <feather-icon
                    class="flex"
                    icon="ArrowRightIcon"
                    svgClasses="w-6 h-6"
                  />
                </div>
              </div>
            </div>

            <div
              class="bg-f8f8f8 radius-6px bg-graycards flex gap-4 items-center mb-2"
            >
              <feather-icon
                class="flex"
                icon="GitPullRequestIcon"
                svgClasses="w-6 h-6"
              />
              <div class="flex items-center justify-between w-full">
                <h1 class="text-sm">Optimize Media Files</h1>

                <div class="flex items-center">
                  <feather-icon
                    class="flex"
                    icon="ArrowRightIcon"
                    svgClasses="w-6 h-6"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleback(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style scoped>
.bg-31b3eb {
  background: #31b3eb;
}
.cust-bgIcon {
  width: 5rem;
  height: 5rem;
  border-radius: 100%;
}
.sitemap-card {
  padding: 24px 26px;
  box-shadow: 0px 4px 16px -2px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}
.cust-rounded svg {
  color: #fff;
  background: #31b3eb;
  padding: 12px;
  border-radius: 100%;
}
.text-737373 {
  color: #737373;
}
.cust-elbutton {
  padding: 12px 30px !important;
}
.bg-ffd03f {
  background: #ffd0ef;
}
.h-150px {
  height: 150px;
}
.cust-wh5rem {
  padding: 17px;
  width: 5rem;
  margin: auto;
  display: flex;
  align-items: center;
  height: 100%;
}
.radius-16px {
  border-radius: 16px;
}
.bg-ffecc7 {
  background: #ffecc7;
}
.text-eb8134 {
  color: #eb8134;
}
.h-200px {
  height: 200px;
}
.text-rgba-gray {
  color: rgba(0, 0, 0, 0.28);
}
.bg-f8f8f8 {
  background: #f8f8f8;
}
.radius-6px {
  border-radius: 6px;
}
.bg-graycards {
  padding: 17px 20px;
}
</style>
